import { styled, Flex } from '@acko-tech/building-blocks.ui.common'

export const IconWrap = styled(Flex)`
  margin-left: auto;
  width: unset;
`
